import React, { useEffect, useState } from "react";
import styles from "./qrstyle.module.css";
import Playstoreimg from "../../assets/Getitonplay.png";
import Loaderspinner from "../Loader/Loaderspinner";
import qrcode from "../../assets/downloadqr.png";

const{REACT_APP_CLIENT_TOKEN} = process.env;
const QRCardApplication = ({  jsonData }) => {
  const [qrData, setQRData] = useState();
  const [inactiveQR, setInactiveQr] = useState(false);

  const clickVerfiyVCqr = () => {
      fetchQr();
  };

  // Fetching QR Code
  const fetchQr = () => {
    setInactiveQr(false);
    fetch(`${process.env.REACT_APP_WALLET_URL}/auth/getVcQr?type=vc`, {
      method: "GET",
      credentials: "omit",
      headers: {
        "Authorization": `Bearer ${REACT_APP_CLIENT_TOKEN}`
      }
    })
      .then((response) => {
        if (response.status === 200) {
          response.json().then((data) => {
            setQRData(data);
            setInactiveQr(false);
          });
        } else {
          response.json().then((data) => {
            console.log(data.error);
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  useEffect(() => {
    if (qrData) {
      const statusCheck = setInterval(() => {
        fetch(
          `${process.env.REACT_APP_WALLET_URL}/auth/checkVC?challenge=${qrData.vc.challenge}&verify=true`,
          {
            headers: {
              "Authorization": `Bearer ${REACT_APP_CLIENT_TOKEN}`
            }
          }
        )
          .then((response) => {
            if (response.status === 200) {
              response.json().then((data) => {
                if (Object.keys(data).includes("session")) {
                  clearInterval(statusCheck);
                  setInactiveQr(true);
                  jsonData(JSON.stringify(data.session), "new");
                }
              });
            } else {
              response.json().then((data) => {
                // console.log(data);
              });
            }
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }, 3000);
      if (inactiveQR) {
        clearInterval(statusCheck);
      }
      setTimeout(() => {
        clearInterval(statusCheck);
        setInactiveQr(true);
      }, 60000);
      return () => {
        clearInterval(statusCheck);
      };
    }
  }, [qrData, inactiveQR]);

  return qrData ? (
    <div className="row m-0">
      <div className="col-md-4 mt-2 mx-auto">
        <div className="card">
          <div className="row ">
            <div className="col-md-6">
              {qrData ? (
                <div className="imgDiv">
                  <img
                    src={qrData.qr}
                    alt="background"
                    className={inactiveQR ? styles.qrImage : styles.qrImageop}
                  />
                  <span
                    className={inactiveQR ? styles.overlayRet : styles.nodis}
                    onClick={fetchQr}
                  >
                    <div className="imgICo">
                      <img
                        src="/refresh.png"
                        className={styles.refershImg}
                        alt="background"
                      />
                    </div>
                    <p className={styles.refreshText}>Refresh the QR code</p>
                  </span>
                </div>
              ) : (
                <Loaderspinner />
              )}
            </div>
            <div className="col-md-6 d-flex justify-content-center align-items-center text-start">
              <div>
                <p className="qr-text pe-none ">
                  <span>
                    Scan the QR to prefill the form
                  </span>
                </p>

                <div className="d-flex justify-content-center align-items-center">
                  <div className="image-container">
                    <a
                      href={`https://play.google.com/store/apps/details?id=com.dhiway.app.batua&pcampaignid=web_share`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className={styles.storeiCons}
                        src={Playstoreimg}
                        alt={`Play store pic`}
                      />
                    </a>
                    <div className="qr-tooltip">
                      <img src={qrcode} alt="QR Code" />
                      <p className="qr-textmodal"> Scan to get the app</p>
                    </div>
                  </div>
                  {/* <img
                      className={styles.storeiCons}
                      src={Iosstoreimg}
                      alt={`ios store pic`}
                    /> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="row m-0">
      <div className="col-md-6 mt-3 mx-auto d-flex justify-content-center align-items-center">
        <button
          type="submit"
          className={"btn btn-primary mb-3 mr-5p btn-sub"}
          onClick={clickVerfiyVCqr}
        >
          Apply using Wallet
        </button>
      </div>
    </div>
  );
};

export default QRCardApplication;
